export default {
  cashRegister: null,
  cashRegisters: null,
  cashRegisterStates: {
    open: "Abierta",
    closed: "Cerrada",
    inactive: "Inactiva",
    closing: "Cuadrando caja",
  },
  orders: null,
  ordersCanceled: null,
  reportProducts: null,
  reportTotals: null,
  reportClose: null,
  paymentMethods: null,
  shift: null,
};
